import React, { useEffect, useState } from "react";
import NanaDetails from "./NanaDetails.jsx"; // Importamos el componente de detalles
import ContractForm from "./ContractForm.jsx"; // Importamos el formulario de contratación
import { FaLock } from "react-icons/fa"; // Ícono de candado
import { motion } from "framer-motion"; // Animaciones
import { getDocumentsFirebase } from "../../../../services/data-firebase.js";
import { useUser } from "../../../../context/UserContext.jsx";
import SvgX from "../../../svg/SvgX.jsx";
 
import imganeNiñerasYALogo from "../../../../assets/imagen/logo-niñeras-ya.JPG"; // Logo de Niñeras YA

export default function NanaAvailable({handleRefresh}) {
    const { user } = useUser(); // Accede a los datos del usuario desde el contexto
  
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para abrir/cerrar el modal
  const [selectedNana, setSelectedNana] = useState(null); // Estado para la niñera seleccionada
  const [showContractForm, setShowContractForm] = useState(false); // Estado para mostrar el formulario de contratación
  const [allNana,setAllNana] = useState(null)

 useEffect(()=>{
    const getAllCitasSubs=async()=>{
      
      try {
        let dataFromFirebase = await getDocumentsFirebase('nana')
        //Filtrar los servicios que coincidan con el idFirestore del usuario
        let nanaSubscriptas = dataFromFirebase.filter(
          (nanas) => nanas.subs === true
        )
        setAllNana(nanaSubscriptas)
   //     console.log(nanaSubscriptas, 'niñeras filtradas');
        
      } catch (error) {
        console.error(error,'error')
      }

    }
    getAllCitasSubs()
  },[user])

  // console.log(allNana,'allNana');
  
  // Abrir el modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Cerrar el modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedNana(null); // Resetear la niñera seleccionada al cerrar el modal
    setShowContractForm(false); // Resetear el formulario de contratación
  };

  // Ver detalles de una niñera
  const viewNanaDetails = (nana) => {
    setSelectedNana(nana);
 //   console.log(nana, 'nana seleccionada')
  };

  // Volver al listado de niñeras
  const backToList = () => {
    setSelectedNana(null);
    setShowContractForm(false); // Resetear el formulario de contratación
  };
  // Seleccionar una niñera y mostrar el formulario de contratación
  const selectNana = () => {

    setShowContractForm(true);
  };

  return (
    <div>
      {/* Botón para abrir el modal */}
      <motion.div
        whileHover={{ scale: 1.05 }} // Efecto de escala al hacer hover
        whileTap={{ scale: 0.95 }} // Efecto de escala al hacer clic
        className="relative"
      >
        <button
          onClick={openModal}
          className="text-white px-4 py-2 rounded-lg hover:bg-[#eec7e9] bg-[#e896ef] transition-all flex items-center gap-2"
        >
          Solicitar Niñeras
          <FaLock className="text-sm" /> {/* Ícono de candado */}
        </button>

        {/* Mensaje flotante para suscriptores */}
        {/* <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="absolute top-12 left-0 bg-gray-800 text-white text-sm px-3 py-2 rounded-lg shadow-lg"
        >
          Solo para suscriptores
        </motion.div> */}
      </motion.div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg w-full max-w-2xl p-6 overflow-y-auto max-h-[90vh]">
            {/* Encabezado del modal */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {selectedNana
                  ? showContractForm
                    ? "Formulario de Contratación"
                    : "Detalles de la Niñera"
                  : "Niñeras Disponibles"}
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500  bg-red-600 rounded-md hover:text-gray-700"
              >
                <SvgX/>{/* Icono de cerrar */}
              </button>
            </div>

            {/* Contenido del modal */}
            {selectedNana ? (
              showContractForm ? (
                // Formulario de contratación
                <ContractForm nana={selectedNana} onBack={closeModal} handleRefresh={handleRefresh} />
              ) : (
                // Detalles de la niñera
                <NanaDetails nana={selectedNana} onSelect={selectNana} onBack={backToList}  />
              )
            ) : (
              // Lista de niñeras
              <ul className="space-y-4">
                {allNana?.map((nana, index) => (
                  <motion.div
                    key={nana.id}
                    initial={{ opacity: 0, y: 20 }} // Animación inicial
                    animate={{ opacity: 1, y: 0 }} // Animación al aparecer
                    transition={{ delay: index * 0.1, duration: 0.5 }} // Retraso y duración
                    whileHover={{ scale: 1.02 }} // Efecto de escala al hacer hover
                    whileTap={{ scale: 0.98 }} // Efecto de escala al hacer clic
                    className="flex flex-row items-center gap-4 border p-4 rounded-lg hover:bg-gray-50 cursor-pointer"
                    onClick={() => viewNanaDetails(nana)}
                  >
                    {/* Imagen de la niñera */}
                    <div className="flex-shrink-0">
                      <img
                        className="w-16 h-16 rounded-full object-cover"
                        src={nana.urlAvatar? nana.urlAvatar : imganeNiñerasYALogo}
                        alt={`Avatar de ${nana.nombre}`}
                      />
                    </div>

                    {/* Información de la niñera */}
                    <div className="flex-grow">
                      <p className="font-bold text-lg">   {nana.name}</p>
                      <p className="text-gray-600"> <strong className="text-sm">Barrio</strong> {nana.neighborhood}</p>
                      <p className="text-gray-600"> <strong className="text-sm">disponibilidad</strong> {nana.availability }</p>
                      <p className="text-gray-600"> <strong className="text-sm">Estudios</strong> {nana.crossStudies }</p>
                      <p className="text-gray-600"> <strong className="text-sm">Movilidad</strong> {nana.mobility }</p>
                    </div>
                  </motion.div>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
}